import React, { useState } from "react";
import { useAuth } from "../context/authContext";
import { useNavigate } from "react-router-dom";
import { Box, Typography } from "@mui/material";

const Login = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [fieldErrors, setFieldErrors] = useState({});
  const { login } = useAuth();

  const validateFields = () => {
    const errors = {};
    if (!username) errors.username = "Username is required.";
    if (!password) errors.password = "Password is required.";
    return errors;
  };

  const handleLogin = () => {
    const errors = validateFields();
    if (Object.keys(errors).length > 0) {
      setFieldErrors(errors);
      return;
    }

    login(username, password)
      .then(() => navigate("/", { replace: true }))
      .catch((error) => {
        setError(error.response?.data?.message || "Something went wrong.");
      });
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        padding: 2,
        borderRadius: 1,
        boxShadow: 3,
      }}
    >
      <Typography
        variant="h5"
        gutterBottom
        sx={{
          color: "#FFF",
          fontFamily: "var(--font-g)",
          fontSize: "45px",
        }}
      >
        Login
      </Typography>
      <Box
        component="form"
        noValidate
        onSubmit={(e) => e.preventDefault()}
        sx={{
          mt: 1,
          width: "100%",
          maxWidth: "400px",
          flexDirection: "column",
        }}
      >
        <Box>
          <label
            htmlFor="username"
            style={{
              color: "#FFF",
              fontSize: "0.9rem",
              display: "block",
              fontFamily: "var(--font-g)",
            }}
          >
            Username
          </label>
          <input
            id="username"
            type="text"
            value={username}
            onChange={(e) => {
              setUsername(e.target.value);
              setFieldErrors((prev) => ({ ...prev, username: null }));
            }}
            placeholder="Enter your username"
            style={{
              width: "100%",
              height: "40px",
              marginTop: "1vh",
              padding: "0.5rem",
              border: "1px solid #ccc",
              fontFamily: "var(--font-g)",
            }}
          />
          {fieldErrors.username && (
            <Typography
              sx={{
                color: "red",
                fontSize: "0.8rem",
                fontFamily: "var(--font-g)",
              }}
            >
              {fieldErrors.username}
            </Typography>
          )}
        </Box>
        <Box sx={{ marginTop: "2vh" }}>
          <label
            htmlFor="password"
            style={{
              color: "#FFF",
              fontSize: "0.9rem",
              display: "block",
              fontFamily: "var(--font-g)",
            }}
          >
            Password
          </label>
          <input
            id="password"
            type="password"
            value={password}
            onChange={(e) => {
              setPassword(e.target.value);
              setFieldErrors((prev) => ({ ...prev, password: null }));
            }}
            placeholder="Enter your password"
            style={{
              width: "100%",
              height: "40px",
              marginTop: "1vh",
              padding: "0.5rem",
              border: "1px solid #ccc",
              fontFamily: "var(--font-g)",
            }}
          />
          {fieldErrors.password && (
            <Typography
              sx={{
                color: "red",
                fontSize: "0.8rem",
                fontFamily: "var(--font-g)",
              }}
            >
              {fieldErrors.password}
            </Typography>
          )}
        </Box>
        <Box sx={{ marginTop: "2vh" }}>
          {error && (
            <Typography sx={{ color: "red", fontFamily: "var(--font-g)" }}>
              {error}
            </Typography>
          )}
        </Box>
        <button
          type="submit"
          onClick={handleLogin}
          style={{
            marginTop: "4vh",
            height: "40px",
            width: "100%",
            borderRadius: "4px",
            backgroundColor: "#fff",
            fontFamily: "var(--font-g)",
            fontSize: "23px",
            border: "none",
            cursor: "var(--pointer-cursor)",
          }}
        >
          Login
        </button>
      </Box>
    </Box>
  );
};

export default Login;
